export function getCurrentDate() {
  const today = new Date();
  const month = today.toLocaleString('en-US', { month: 'long' });
  const day = String(today.getDate()).padStart(2, '0');
  const year = today.getFullYear();

  const formattedDate = `${month} ${day}, ${year}`;
  return formattedDate;
}